import { curry, reduce, isNil } from 'lodash/fp';
/**
 * Used to conditionally apply functions on the streamlined value depending
 * on the previous results.
 *
 * @param {Array} functions - Functions to iterate over.
 * @param {any} data - Streamlined result from the previous call.
 *
 * @example
 * takeFirstDefinedResult([find(isNumber), head], collection)
 */

export default curry(function (functions, data) {
  return reduce(function (result, func) {
    return isNil(result) ? func(data) : result;
  }, undefined, functions);
});